export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/bag-icon.a8219b5d.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};